import Image from "next/image";

import { Bezel, Media, Phone, Screen, SideBtn, Wrap } from "./MobilePreview.styled";

export default function MobilePreview({
	videoUrl,
	imageUrl,
	poster = "/assets/device_preview/video_preview.png",
	alt = "",
	sticky = true
}) {
	if (!videoUrl && !imageUrl) return null;

	return (
		<Wrap $sticky={sticky}>
			<Phone>
				<SideBtn $side="left" $kind="silent" />
				<SideBtn $side="left" $kind="vol-up" />
				<SideBtn $side="left" $kind="vol-down" />
				<SideBtn $side="right" $kind="power" />
				<Bezel>
					<Screen>
						<Media>
							{videoUrl ? (
								<video autoPlay muted loop preload="auto" poster={poster} playsInline webkit-playsinline="true">
									<source src={videoUrl} type="video/mp4" />
								</video>
							) : (
								<Image unoptimized fill sizes="340px" src={imageUrl} alt={alt} style={{ objectFit: "cover" }} />
							)}
						</Media>
					</Screen>
				</Bezel>
			</Phone>
		</Wrap>
	);
}
